export default function ScaledSvg({
  logicalWidth,
  logicalHeight,
  scale = 1,
  children,
  style
}) {
  const parsedScale = Number(scale);

  // Prevent accidental giant or unusably small widgets.
  const safeScale = Number.isFinite(parsedScale)
    ? Math.min(1.6, Math.max(0.75, parsedScale))
    : 1;

  return (
    <div
      style={{
        width: "100%",
        overflow: "visible"
      }}
    >
      <svg
        width={logicalWidth * safeScale}
        height={logicalHeight * safeScale}
        viewBox={`0 0 ${logicalWidth} ${logicalHeight}`}
        preserveAspectRatio="xMinYMin meet"
        style={{
          display: "block",
          maxWidth: "none",
          ...style
        }}
      >
        {children}
      </svg>
    </div>
  );
}